export default __webpack_public_path__ + "static/media/location-maps.83b0731f.gif";